<script setup lang="ts">
import { ref, watchEffect } from 'vue';
import { useRouter } from 'vue-router'
import ScheduleList from '../components/ScheduleList.vue'
const phone = ref('')
const token = ref('')
const router = useRouter()

watchEffect(async () => {
  const beteToken = localStorage.getItem('bete-token') || ''
  if (!beteToken) {
    console.log('Login')
    return router.push('/')
  } else {
    token.value = beteToken
  }
})

const isJSONValid = (str: string) => {
  try {
    JSON.parse(str)
  } catch (e) {
    return false
  }
  return true
}

window.addEventListener('message', function (event) {
  console.log(`Chatwoot event`, event)
  if (!isJSONValid(event.data)) {
    return;
  }

  const eventData = JSON.parse(event.data);
  const phoneNumber = eventData?.data?.contact?.phone_number

  if (phoneNumber) {
    phone.value = phoneNumber.replace(/\D/g, '')
    console.log(`Found number`, phone.value)
  }
});

window.parent.postMessage('chatwoot-dashboard-app:fetch-info', '*')
</script>

<template>
  <ScheduleList v-if="phone && token" :phone="phone" :token="token" />
  <div v-else>
    Aguardando receber o número de telefone do chatwoot...
  </div>
</template>
